module.exports = __webpack_public_path__ + "img/icons B_6.8f74b95a.png";